module.exports = __webpack_public_path__ + "img/svg/step1.05392bda2290f28fe6553580258a8bba.svg";